module.exports = __webpack_public_path__ + "img/648.bbd1a94a.png";